import React from 'react';
import { mdiHelpCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { observer } from 'mobx-react';
import { Modal, ModalHeader, ModalFooter, ModalBody, Container } from 'reactstrap';

interface IInfoModalIconProps {
    modalTriggerCallback;
    title: string;
}
interface IInfoModalProps {
    showHelpModal: boolean;
    closeHelpModal;
    helpModalTitle: string;
    helpModalContent: string;
}

const InfoModalComponent = (props: IInfoModalProps) => {

    return (
        <Modal
        isOpen={props.showHelpModal}
        toggle={props.closeHelpModal}
        centered={true}
        className="eft-action-modal"
        aria-label={props.helpModalTitle}
      >
        <ModalHeader toggle={props.closeHelpModal} className='header-info-detail' >
          <div className="display-flex flex-align-center">
            <strong >{`Information details on ${props.helpModalTitle}`}</strong>
          </div>
          {/* Commented link to open content in a new tab */}
          {/* <a className="href-info-detail" href="" target="_blank">
            Open Information in a New Tab
          </a> */}
        </ModalHeader>
        <ModalBody>
          <Container>
            <p>{props.helpModalContent}</p>
          </Container>
        </ModalBody>
        <ModalFooter>
          <button className="usa-button usa-button--outline" onClick={props.closeHelpModal}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    )
}
const InfoModalIconComponent = (props: IInfoModalIconProps) => {
    return (
        <button 
              className='usa-button usa-button--unstyled information-button-icon'
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                props.modalTriggerCallback();
              }}
            >
              <Icon className='ml-1' path={mdiHelpCircleOutline}  title={`More information on ${props.title}`} size={1} color="#005ea2" />
            </button>
    )
}

export const InformationModal = observer(InfoModalComponent);
export const InformationModalIcon = observer(InfoModalIconComponent);